import {inject, Injectable} from "@angular/core";

import {StorageLocal} from "@app/core/shared/domain/storage/storage.local";
import {PromoterRepo} from "@app/core/promoter/domain/promoter-repo";

@Injectable({
    providedIn: "root",
})
export class PromoterDataRepo extends PromoterRepo {
    private static readonly PROMOTER_STORAGE_KEY = 'promoter';

    private readonly localStorage = inject(StorageLocal);

    save(promoter: string): void {
        this.localStorage.setItem(PromoterDataRepo.PROMOTER_STORAGE_KEY, promoter);
    }

    get(): string | null {
        return this.localStorage.getItem(PromoterDataRepo.PROMOTER_STORAGE_KEY) ?? null;
    }

    delete(): void {
        this.localStorage.removeItem(PromoterDataRepo.PROMOTER_STORAGE_KEY);
    }
}
